import { FC } from 'react'

import { MainLayoutProps } from '../../layouts/MainLayout'
import { BannerListingProps } from '../../components/BannerListing'
import { ProductsGridProps } from '../../components/ProductsGrid'
import SectionWrapper from '../../components/SectionWrapper'
import { SortingFiltersProps } from '../../components/SortingFilters'
import { ActionButtonProps } from '../../components/ActionButton'
import { TextBannerProps } from '../../components/TextBanner'

import * as SC from './styled'

export type ProductsTemplateProps = MainLayoutProps & {
  banner?: BannerListingProps
  sortingFilters?: SortingFiltersProps
  products: ProductsGridProps
  seeMoreButton?: ActionButtonProps
  infoBanner?: TextBannerProps
}

const ProductsTemplate: FC<ProductsTemplateProps> = ({
  banner,
  sortingFilters,
  products,
  seeMoreButton,
  infoBanner,
  ...layout
}) => {
  return (
    <SC.Layout {...layout}>
      {banner && <SC.Banner {...banner} />}
      {sortingFilters && <SC.FiltersBanner {...sortingFilters} />}
      <SectionWrapper>
        <SC.ProductList {...products} />
      </SectionWrapper>
      {seeMoreButton && (
        <SC.Centered spacing={'big'}>
          <SC.SeeMoreButton {...seeMoreButton} />
        </SC.Centered>
      )}
      {infoBanner && <SC.InfoBanner {...infoBanner} />}
    </SC.Layout>
  )
}

export default ProductsTemplate
